import { formatUrl } from '../../helperFunctions'
import { PROJECT_TITLES } from '../ProjectOverview/constants'

export const DETAIL = [
  // Government
  {
    title: PROJECT_TITLES.government.la,
    link: formatUrl(PROJECT_TITLES.government.la),
    bg: 'bg-gov-la-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/state/la-county/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/state/la-county/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/state/la-county/eidim-3.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/state/la-county/eidim-4.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Los Angeles County Sheriff, 2017',
      },

      {
        key: 'Type of Service',
        value: 'AV and VideoWall Installation'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'Installation of LA Sheriff’s antiquated video display systems with a Direct View (DV) LED Video Wall in the Sheriff’s Communications Center (SCC) for the Los Angeles Regional Interoperable Communications System (LA-RICS) Network Operation Center (NOC). The requirement is for an end to end solution to include display systems, audio video switching, video wall windowing processor, and control systems.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.government.metrolink,
    link: formatUrl(PROJECT_TITLES.government.metrolink),
    bg: 'bg-gov-metrolink-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/state/metrolink/eidim-1.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Southern California Regional Authority-Metrolink, CA, 2017',
      },

      {
        key: 'Type of Service',
        value: 'Procure and Install Video Wall System'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'To procure and install video wall system for Metrolink security operations center and to integrate all devices in relation to audio-visual and control system. The Authority is requesting bids to furnish and install a new Tiled LCD Video Wall System in its new Security Operations Center (SOC) room at the Metrolink Operations Center (MOC) building in Pomona, CA.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.government.starbase,
    link: formatUrl(PROJECT_TITLES.government.starbase),
    bg: 'bg-gov-starbase-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/state/starbase/eidim-1.jpg'],
    details: [
      {
        key: 'Client',
        value: 'StarBase, 2015',
      },

      {
        key: 'Type of Service',
        value: 'AV Installation'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'AV system installation for three class room, one presentation room and outside lunch area; and to integrate all devices in relation to audio-visual system.'
      }
    ],
  },

  // Education

  {
    title: PROJECT_TITLES.education.palomar,
    link: formatUrl(PROJECT_TITLES.education.palomar),
    bg: 'bg-edu-palomar-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-3.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-4.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-5.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-6.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/palomar-college/eidim-7.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Palomar College School District, 2018',
      },

      {
        key: 'Type of Service',
        value: 'AV Equipment Installations'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Equipment list',
        value: 'Extron, Cisco, Belkin, Middle Atlantic, Hitachi, Peerless-AV, Da-Lite'
      },

      {
        key: 'Description',
        value: 'Palomar College AV Equipment installation in 3 buildings, North Education Center, South Education Center and the Learning Resource Center. There are 90 rooms consisting of conference, meeting, study rooms with newly installed AV systems.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.education.allied,
    link: formatUrl(PROJECT_TITLES.education.allied),
    bg: 'bg-edu-allied-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/allied-health/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/allied-health/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/allied-health/eidim-3.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/allied-health/eidim-4.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Compton College Unified School District, 2014',
      },

      {
        key: 'Type of Service',
        value: 'AV Equipment Installations'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'General Contractor',
        value: 'AMG & Associates'
      },

      {
        key: 'Description',
        value: 'EIDIM worked on the Projector Screen, Video Projectors, and Communications Distributed Audio and Video System for this project. In this project we have Installed Extron Control System, projector, Audio Amplifier, Microphones, speakers, LED display, switcher, distributor, router, matrix, etc. for 11 Classrooms.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.education.santa,
    link: formatUrl(PROJECT_TITLES.education.santa),
    bg: 'bg-edu-santa-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/santa-monica/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/santa-monica/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/education/santa-monica/eidim-3.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Santa Monica Community College District, 2016',
      },

      {
        key: 'Type of Service',
        value: 'AV System for Center for Teaching'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'Installation of modern presentation and interactive display with an up to date technology to use for multi-use learning and meetings. The scope includes the installation and integration of Display, Video and Audio Systems, Control Systems, Equipment, Racks, Hardware, and other miscellaneous materials.'
      }
    ],
  },

  // Private

  {
    title: PROJECT_TITLES.private.bakemark,
    link: formatUrl(PROJECT_TITLES.private.bakemark),
    bg: 'bg-private-bakemark-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/private/bakemark/eidim-1.jpg'],
    details: [
      {
        key: 'Client',
        value: 'BakeMark USA, 2011',
      },

      {
        key: 'Type of Service',
        value: 'NEW AV and VTC System'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'Installation of AV and VTC system with dual LCD screen. The conference room requested Poly com HD camera and dual displays for presentation and video conferencing, and was installed with digital control matrix audio. Equipment List: Samsung LCD 65” Polycom Codec/Eagle Eye Camera, Crestron DM-MD 8X8, Nexia TC, Extron XPA-1002, Shure MX395.'
      }
    ],
  },

  // House of worship
  {
    title: PROJECT_TITLES.worship.kwang,
    link: formatUrl(PROJECT_TITLES.worship.kwang),
    bg: 'bg-worship-kwang-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/kwang-myung/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/kwang-myung/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/kwang-myung/eidim-3.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/kwang-myung/eidim-4.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/kwang-myung/eidim-5.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Kwang Myung Church, 2006',
      },

      {
        key: 'Type of Service',
        value: 'Audio Visual Integration'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'The system can apply for this project with a blending image and a large display screen and monitor in a control room. It related to the digital sound system and acoustic treatment. Brighter and Sharper Images, Even Viewing Coverage, Multi-Screen System – Multiple information can be presented at once. Panoramic Image – Project spectacular images by using screen blend processor. Installation of large displays (650”, LED, Plasma, LCD), projectors (5x12,000 & 5x5,000 lumens), Digital Image blending system, Digital sound system, Line array speakers Video control monitor system, etc.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.worship.promised,
    link: formatUrl(PROJECT_TITLES.worship.promised),
    bg: 'bg-worship-promised-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/promised-church/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/promised-church/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/promised-church/eidim-3.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/promised-church/eidim-4.jpg'],
    details: [
      {
        key: 'Client',
        value: 'The Promised Church',
      },

      {
        key: 'Type of Service',
        value: 'Audio Visual Integration'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'Main Sanctuary Renovation Sound System Design/Installation.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.worship.sae,
    link: formatUrl(PROJECT_TITLES.worship.sae),
    bg: 'bg-worship-sae-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/sae-hyun-church/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/sae-hyun-church/eidim-2.jpg'],
    details: [
      {
        key: 'Client',
        value: ' Sae Hyun Church',
      },

      {
        key: 'Type of Service',
        value: 'Audio Visual Integration'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'New Main Sanctuary Sound, Multi Media, and Large Display System Design/Installation'
      }
    ],
  },

  {
    title: PROJECT_TITLES.worship.choong,
    link: formatUrl(PROJECT_TITLES.worship.choong),
    bg: 'bg-worship-choong-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/chong-hyun-church/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/chong-hyun-church/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/chong-hyun-church/eidim-3.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/chong-hyun-church/eidim-4.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Choong Hyun Church, 2009',
      },

      {
        key: 'Type of Service',
        value: 'New Building Audio Visual Installation'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'Large display and multi &amp; blending images for video system apply to this project. The sound system of the line array, digitalized system, and acoustic treatment are applicable.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.worship.young,
    link: formatUrl(PROJECT_TITLES.worship.young),
    bg: 'bg-worship-young-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/young-nak-church/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/young-nak-church/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/young-nak-church/eidim-3.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Young Nak, 2015',
      },

      {
        key: 'Type of Service',
        value: ' Audio Visual, Lighting System, and Acoustic Renovation'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'EIDIM Provided a sound system installation and acoustical treatment.We completed as- built in functional drawings for the sound system, Rigging, and Speaker Installation, Sound Tuning with Computerize RTA(Real- time analyzer, Initial Programming of digital devices and software updates, Operation, and Training for General sound engineering system configuration.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.government.micc,
    link: formatUrl(PROJECT_TITLES.government.micc),
    bg: 'bg-worship-young-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/young-nak-church/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/young-nak-church/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/house-of-worship/young-nak-church/eidim-3.jpg'],
    details: [
      {
        key: 'Client',
        value: 'MICC Fort Irwin, 2018',
      },

      {
        key: 'Type of Service',
        value: 'Audio Visual System Upgrade'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: 'Complete AV system upgrade with detailed engineering, equipment coordination and supply, control system configuration & programming, Factory acceptance testing, complete system installation, with site acceptance testing, and user training for 2 Buildings with 4 rooms in total.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.government.miramar,
    link: formatUrl(PROJECT_TITLES.government.miramar),
    bg: 'bg-gov-federal-miramar-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/federal/miramar-recording/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/federal/miramar-recording/eidim-2.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Miramar Recording Studio, 2010',
      },

      {
        key: 'Type of Service',
        value: 'AV Installation'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Description',
        value: '3rd Marine Aircraft Wing Band AV- Recording Studio Installation of Recording Studio and control room Sound System Sale & acoustic treatment, and display system. SSL Duality, Protocol, Mac, Genetec Monitors, microphones, furniture, absorber, diffuser panels, etc.'
      }
    ],
  },

  {
    title: PROJECT_TITLES.government.veteran,
    link: formatUrl(PROJECT_TITLES.government.veteran),
    bg: 'bg-gov-federal-veteran-1',
    gallery: ['https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/federal/veteran-affairs/eidim-1.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/federal/veteran-affairs/eidim-2.jpg', 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/market/government/federal/veteran-affairs/eidim-3.jpg'],
    details: [
      {
        key: 'Client',
        value: 'Veteran Affairs Southern Nevada Healthcare System',
      },

      {
        key: 'Type of Service',
        value: 'Videowall Signage Installation'
      },

      {
        key: 'AV Integrator',
        value: 'EIDIM Group, INC.'
      },

      {
        key: 'Equipment list',
        value: 'Crestron, Planar, Cisco, Middle Atlantic, Seimon, QSC'
      },

      {
        key: 'Description',
        value: 'Turnkey Audio Visual project with equipment, installation, and testing system to support the Command Post at the Southern VA Nevada location. We have supplied and Installed, AV Racks, Jack locations for 6 monitors, conference rooms entrance lighted solutions with programming, cabling, labelling, terminations for new AV and data/Telecom runs.'
      }
    ],
  },
]